import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";

export class RemoveAuthorizedTokenUsecase {
  constructor(private readonly appAccountSettingRepo: AppAccountSettingRepository) {}

  async execute(): Promise<void> {
    return this.appAccountSettingRepo.removeAuthorizedToken();
  }
}
